import { getKoName } from '@cck/common/dist/data/Translation'
import { hasThreeCategories, noProcessName } from '@cck/common/dist/utils/Config'
import _ from 'lodash'
import React from 'react'

import TableItem from '../../../common/TableItem'
import SelectItem, { selectValidator } from './SelectItem'
import { FormTypes } from './Types'

export interface Props {
  type: 'process' | 'risk' | 'control'
  isNew: boolean
  formValues: FormTypes
  getReferenceIds?: (
    cycle: string,
    category: string,
    subCategory: string | undefined,
    processId: string
  ) => Record<string, string>
}

const RiskSelectFormItem: React.FC<Props> = ({ type, isNew, formValues, getReferenceIds }) => {
  if (type !== 'control') {
    return <></>
  }

  const options = React.useMemo(() => {
    if (!getReferenceIds) {
      return {}
    }
    return getReferenceIds(
      formValues.cycle,
      formValues.category,
      hasThreeCategories() ? formValues.subCategory : undefined,
      formValues.processId
    )
  }, [getReferenceIds, formValues])

  return (
    <>
      <SelectItem
        required
        dataKey="riskId"
        disabled={
          _.isEmpty(formValues.cycle) ||
          _.isEmpty(formValues.category) ||
          (hasThreeCategories() && _.isEmpty(formValues.subCategory)) ||
          !isNew
        }
        name={getKoName('risk', 'id')}
        options={options}
        rules={[() => ({ validator: selectValidator(`${getKoName('risk', 'id')}를`) })]}
      />
      <TableItem name={getKoName('risk', 'name')} minHeight={48}>
        {formValues.riskName}
      </TableItem>
    </>
  )
}

export default RiskSelectFormItem
